export enum CategoryType {
  Category = 1,
  SharedList = 2,
  GroupStart = 3,
  GroupEnd = 4
}
